import React from "react";
import { Flex, Text } from "@fluentui/react-northstar";
import styles from "./managerReportCell.module.scss";
import TargetProgressBar from "goalsCard/tabs/ScoreCardReport/targetProgressBar/TargetProgressBar";
import pl from "shared/messages/pl";
import { getTargetValueFormat } from "shared/reports/utils/ReportUtils";
import { ScorecardGoal } from "goalsCard/service/api/models";
import { ScorecardGoalV3_PublicStatus } from "shared/service/api/generated";
import { constants } from "shared/constants";
import { goalCodes } from "shared/constants/reportConstants";

interface ManagerReportCellProps {
    report: ScorecardGoal;
    showTodayProgressValue: boolean;
    todayProgressValue?: number;
}

const ManagerReportCell: React.FC<ManagerReportCellProps> = (props: ManagerReportCellProps) => {
    const calculateValueLeft = () => {
        if (props.report.currentValue === undefined || props.report.targetValue === undefined) {
            return undefined;
        }

        return Math.max(0, props.report.targetValue - props.report.currentValue);
    };

    const renderProgressBar = () => {
        switch (props.report.title) {
            case goalCodes.apeGz:
                return (
                    <Text weight="semibold" size="medium">
                        {props.report.currentValue === undefined
                            ? constants.noValue
                            : getTargetValueFormat(props.report.currentValue, props.report.unitType)}
                    </Text>
                );
            default:
                return (
                    <TargetProgressBar
                        targetProgress={props.report.progress}
                        targetProgressValue={props.report.progressValue}
                        showWarningIndicator={props.report.status === ScorecardGoalV3_PublicStatus.NOK ? true : false}
                        highlightTextTargetProgressValue={false}
                        showTodayProgressValue={props.showTodayProgressValue}
                        todayProgressValue={props.todayProgressValue}
                        showOnlyProgressValue={props.report.title !== goalCodes.lapse}
                    />
                );
        }
    };

    const renderTarget = () => {
        switch (props.report.title) {
            case goalCodes.apeGz:
                return <div className={styles.target}>&nbsp;</div>;
            case goalCodes.lapse:
                return (
                    <div className={styles.target}>
                        {getTargetValueFormat(props.report.targetValue, props.report.unitType)}
                        /&nbsp;
                        {getTargetValueFormat(props.report.currentValue, props.report.unitType)}
                    </div>
                );
            default:
                return (
                    <div className={styles.target}>
                        {getTargetValueFormat(props.report.currentValue, props.report.unitType)}
                        /&nbsp;
                        {getTargetValueFormat(props.report.targetValue, props.report.unitType)}
                    </div>
                );
        }
    };

    const renderFoooter = () => {
        switch (props.report.title) {
            case goalCodes.apeGz:
            case goalCodes.lapse:
                return <div className={styles.text}>&nbsp;</div>;
            default:
                return (
                    <div className={styles.text}>
                        {pl.reports.managerReportCell.leftLabel(
                            getTargetValueFormat(calculateValueLeft(), props.report.unitType)
                        )}
                    </div>
                );
        }
    };

    return (
        <Flex column>
            {renderProgressBar()}
            {renderTarget()}
            {renderFoooter()}
        </Flex>
    );
};

export default ManagerReportCell;
